"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const TipsItem_1 = __importDefault(require("../TipsItem"));
const OFFSET = 0;
const ANIMATION_DURATION = 200;
function TipsPopover() {
    const [isOpen, setIsOpen] = (0, react_1.useState)(true);
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const containerRef = (0, react_1.useRef)(null);
    (0, ui_1.useOutsideClick)(containerRef, () => {
        setIsOpen(false);
        setTimeout(() => {
            navigate(-1);
        }, ANIMATION_DURATION);
    });
    const tipsOptionsList = [
        {
            title: t(i18n_1.Strings.tips.options.getStarted.title),
            link: t(i18n_1.Strings.tips.options.getStarted.url),
        },
        {
            title: t(i18n_1.Strings.tips.options.customerSupport.title),
            link: t(i18n_1.Strings.tips.options.customerSupport.url),
        },
        {
            title: t(i18n_1.Strings.tips.options.blog.title),
            link: t(i18n_1.Strings.tips.options.blog.url),
        },
    ];
    return ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: ANIMATION_DURATION, mountOnEnter: true, appear: true, unmountOnExit: true, nodeRef: containerRef, children: (0, jsx_runtime_1.jsxs)(Popover, { ref: containerRef, children: [(0, jsx_runtime_1.jsx)(StyledHeader, { type: ui_1.HeaderType.Default, children: (0, i18n_1.Localized)(i18n_1.Strings.tips.title) }), (0, jsx_runtime_1.jsx)(ItemsContainer, { children: tipsOptionsList.map((item, index) => ((0, jsx_runtime_1.jsx)(TipsItem_1.default, { title: item.title, link: item.link }, index))) })] }) }) }));
}
exports.default = TipsPopover;
const hiddenStyles = (0, styled_components_1.css) `
  transform: translateY(100%);
`;
const visibleStyles = (0, styled_components_1.css) `
  transform: translateY(-${OFFSET}px);
`;
const Container = styled_components_1.default.div `
  display: flex;
  position: absolute;

  justify-content: center;
  align-items: center;

  left: 0;
  top: 0;
  z-index: 1;

  width: 100vw;
  height: 100vh;

  background: rgba(20, 20, 20, 0.73) !important;
`;
const Popover = styled_components_1.default.div `
  width: 450px;
  height: fit-content;

  background-color: ${({ theme }) => theme.designSystem.contentBackground};
  opacity: 1;
  &.appear,
  &.enter {
    ${hiddenStyles}
  }

  &.appear-active,
  &.enter-active {
    ${visibleStyles};

    transition: transform ${ANIMATION_DURATION}ms ease-in;
  }

  &.appear-done,
  &.enter-done {
    ${visibleStyles};
  }

  &.exit {
    ${visibleStyles};
  }

  &.exit-active {
    ${hiddenStyles};

    transition: transform ${ANIMATION_DURATION}ms ease-in;
  }

  &.exit-done {
    ${hiddenStyles};
  }
`;
const StyledHeader = (0, styled_components_1.default)(ui_1.Header) `
  font-size: 18px;
`;
const ItemsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  height: 100%;

  background-color: ${({ theme }) => theme.designSystem.highlightedBackground};

  font-size: 18px;
`;
